// Rauchpartikel als ein InstancedMesh. Emitter liefern Position, Rate und Farbe.
import * as THREE from "three"
import { COLORS } from "../world/palette.js"

const MAX = 420
const dummy = new THREE.Object3D()
const color = new THREE.Color()

export class Smoke {
  constructor(scene, quality = "high") {
    this.max = quality === "low" ? 160 : MAX
    const geometry = new THREE.IcosahedronGeometry(0.5, 0)
    const material = new THREE.MeshStandardMaterial({ flatShading: true, roughness: 1, transparent: true, opacity: 0.85 })
    this.mesh = new THREE.InstancedMesh(geometry, material, this.max)
    this.mesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage)
    this.mesh.frustumCulled = false
    scene.add(this.mesh)
    this.particles = Array.from({ length: this.max }, () => ({ life: 0, ttl: 0, pos: new THREE.Vector3(), vel: new THREE.Vector3(), size: 1 }))
    this.cursor = 0
    this.emitters = []
    for (let i = 0; i < this.max; i++) {
      this.mesh.setColorAt(i, color.set(COLORS.smokeDirty))
      dummy.scale.setScalar(0)
      dummy.updateMatrix()
      this.mesh.setMatrixAt(i, dummy.matrix)
    }
  }

  // position: Vector3 (Welt), rate: Partikel pro Sekunde, color: hex, size: Grundgröße
  addEmitter(options) {
    const emitter = { rate: 2, color: COLORS.smokeDirty, size: 1, spread: 0.3, rise: 1.4, active: true, acc: 0, ...options }
    this.emitters.push(emitter)
    return emitter
  }

  removeEmitter(emitter) {
    this.emitters = this.emitters.filter((e) => e !== emitter)
  }

  clear() {
    this.emitters = []
  }

  spawn(emitter) {
    const p = this.particles[this.cursor]
    p.life = 0
    p.ttl = 3 + Math.random() * 1.5
    p.pos.copy(emitter.position).add(new THREE.Vector3((Math.random() - 0.5) * emitter.spread, 0, (Math.random() - 0.5) * emitter.spread))
    p.vel.set(0.25 + Math.random() * 0.2, emitter.rise * (0.8 + Math.random() * 0.4), (Math.random() - 0.5) * 0.2)
    p.size = emitter.size * (0.7 + Math.random() * 0.5)
    this.mesh.setColorAt(this.cursor, color.set(emitter.color))
    this.cursor = (this.cursor + 1) % this.max
  }

  update(dt) {
    for (const emitter of this.emitters) {
      if (!emitter.active || emitter.rate <= 0) continue
      emitter.acc += dt * emitter.rate
      while (emitter.acc >= 1) {
        emitter.acc -= 1
        this.spawn(emitter)
      }
    }
    for (let i = 0; i < this.max; i++) {
      const p = this.particles[i]
      if (p.ttl <= 0) continue
      p.life += dt
      const t = p.life / p.ttl
      if (t >= 1) {
        p.ttl = 0
        dummy.scale.setScalar(0)
      } else {
        p.pos.addScaledVector(p.vel, dt)
        const s = p.size * Math.sin(Math.PI * Math.min(1, t * 1.3)) * (0.6 + t)
        dummy.position.copy(p.pos)
        dummy.rotation.set(t * 2, t * 3, 0)
        dummy.scale.setScalar(Math.max(0, s))
      }
      dummy.updateMatrix()
      this.mesh.setMatrixAt(i, dummy.matrix)
    }
    this.mesh.instanceMatrix.needsUpdate = true
    if (this.mesh.instanceColor) this.mesh.instanceColor.needsUpdate = true
  }
}
